
export default function range(min, max, step = 1) {
	let arr = [];

	for (let i = min; i <= max; i += step) {
		arr.push(i)
	}

	return arr
}
